module.exports = __webpack_public_path__ + "static/media/logo.aa92c567.png";